import * as vp from 'vopay';
import { FunctionComponent } from 'react';
import { Formik } from 'formik';
import { useTranslation } from 'react-i18next';
import useBuildUpdateWebhookRows from './buildUpdateWebhooksRows.helper';

const { Box, Button, BackButton, Title, Table, TextField } = vp;

type DefaultValues = {
  accountonboarding: string;
};

type ToggleValues = {
  accountonboarding: boolean;
};

type UpdateWebhookProps = {
  defaultValues: DefaultValues;
  toggleValues: ToggleValues;
  onSubmit: () => void;
  onBack: () => void;
};
type FC = FunctionComponent<UpdateWebhookProps>;

const UpdateWebhooksReview: FC = (props: UpdateWebhookProps) => {
  const { defaultValues, toggleValues, onSubmit, onBack } = props;
  const updateWebhookRows = useBuildUpdateWebhookRows();
  const { t } = useTranslation('translations', { keyPrefix: 'Settings.Webhooks.Update.Review' });
  const { t: tGlobal } = useTranslation('translations', { keyPrefix: 'Global' });
  return (
    <Formik enableReinitialize initialValues={defaultValues} onSubmit={onSubmit} validateOnChange validateOnBlur>
      {({ handleSubmit }) => {
        const updateWebhookTable: vp.TableProps = {
          name: 'update-webhook-fields',
          columns: {
            Field: { header: t('event', { defaultValue: 'Event' }) },
            Toggle: { header: t('enable', { defaultValue: 'Enable Events' }), align: 'left' },
            Input: { header: t('url', { defaultValue: 'URL' }) },
          },
          rows: updateWebhookRows.map(({ label, id, preset }) => ({
            Field: label,
            Toggle: (
              <div style={{ paddingLeft: '40px' }}>
                {toggleValues[id as keyof ToggleValues] === true ? tGlobal('yes') : tGlobal('no')}
              </div>
            ),
            Input: (
              <TextField
                preset={preset}
                key={id}
                name={id}
                variant="background"
                onBlur={() => {}}
                onChange={() => {}}
                value={defaultValues[id as keyof DefaultValues]}
                disabled
              />
            ),
          })),
        };
        return (
          <form onSubmit={handleSubmit}>
            <Box mb="lg" jc="fs" ai="center" gap="common">
              <BackButton variant="arrow" backButtonEnabled onClick={onBack} />
              <Title title={t('pageTitle', { defaultValue: 'Review and Save' })} />
            </Box>
            <Table {...updateWebhookTable} />
            <Box width="100%" jc="fe" mt="lg">
              <Button id="webhook-submit" type="submit" label={tGlobal('Buttons.save')} />
            </Box>
          </form>
        );
      }}
    </Formik>
  );
};

export default UpdateWebhooksReview;
